var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckIn = function SvgCheckIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 19.575 19.575"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.784 0q1.812 0 3.375.57 1.459.53 2.653 1.439l-.93.928a8.4 8.4 0 0 0-2.259-1.195 8.6 8.6 0 0 0-2.839-.46c-2.412 0-4.44.811-6.067 2.437-1.628 1.626-2.442 3.654-2.442 6.07s.813 4.445 2.44 6.071c1.628 1.627 3.656 2.44 6.068 2.44 2.413 0 4.44-.813 6.069-2.439s2.442-3.654 2.442-6.071q0-.726-.11-1.415a8.6 8.6 0 0 0-.29-1.22l1.004-1.009c.204.52.367 1.056.479 1.61q.198.977.198 2.03 0 2.087-.759 3.871a9.7 9.7 0 0 1-2.08 3.108 9.6 9.6 0 0 1-3.105 2.065q-1.783.745-3.844.745-2.085 0-3.87-.747a9.5 9.5 0 0 1-3.105-2.064 9.5 9.5 0 0 1-2.065-3.106Q.001 11.873 0 9.788q0-2.061.745-3.844A9.6 9.6 0 0 1 2.81 2.84 9.7 9.7 0 0 1 5.918.759Q7.702 0 9.784 0m9.242 2.403c.27.264.272.698.005.965L8.322 14.07 4.95 10.68a.67.67 0 0 1 .947-.945l2.284 2.283.14.141 9.75-9.75a.68.68 0 0 1 .954-.005"
  })));
};
export default SvgCheckIn;